
















import Vue from 'vue';
import Component from 'vue-class-component';

import util from '../common/utility';
import { Watch } from 'vue-property-decorator';

@Component({})
export default class extends Vue {
    public classes = ['modal', 'fade'];
    public image = '';

    private imagePath = './images/';

    private images = [
        require(this.imagePath + 'christianjesuschildlovejpg.jpg'),
        // require(this.imagePath + 'dab-step.jpg'),
        require(this.imagePath + 'good-job-emoji.jpg'),
        // require(this.imagePath + 'thumbs-up.jpg'),
        require(this.imagePath + 'v.jpg'),
        require(this.imagePath + 'way-to-go.jpg'),
        require(this.imagePath + 'well-done.jpg')
    ];

    private lastImage = require(this.imagePath + 'thats-all-folks.jpg');

    private imageIndex = -1;

    public created() {
        util.eventBus.$on('image-popup', (data: any) => {
            switch (data) {
                case -2:
                    this.imageIndex = -2;
                    break;
                case -1:
                    this.imageIndex = -1;
                    break;
                default:
                    this.imageIndex = Math.floor(Math.random() * (this.images.length));
                    break;
            }
        });
    }

    @Watch('imageIndex')
    public imageIndexCheck() {
        if ( this.imageIndex > -3 ) {
            setTimeout(() => {
                this.classes = ['modal fade'];
            }, util.popupTimer);

            this.classes.push('show');

            if ( this.imageIndex > -3 && this.imageIndex < 0 ) {
                this.image = this.lastImage;
            } else if ( this.imageIndex >= 0 ) {
                this.image = this.images[this.imageIndex];
            }
        }
    }
}
